import React, { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import ContentPlayerModalContainer from '../Player/ContentPlayerModalContainer';

const EmbeddedLayout = () => {

  const containerRef = useRef(null);

  useEffect(() => {
    // Function to send height to parent window
    const sendHeightToParent = () => {
      if (window.parent && window.parent !== window) {
        const height = Math.max(
          document.documentElement.scrollHeight,
          document.body.scrollHeight,
          600 // minimum height
        );
        
        window.parent.postMessage({
          type: 'beetsol-lms-resize',
          height: height
        }, '*');
      }
    };

    // Send initial height after a short delay
    const timer = setTimeout(sendHeightToParent, 1000);

    // Create ResizeObserver to watch for content changes
    const resizeObserver = new ResizeObserver(() => {
      sendHeightToParent();
    });

    // Create MutationObserver to watch for DOM changes
    const mutationObserver = new MutationObserver(() => {
      setTimeout(sendHeightToParent, 100);
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
      mutationObserver.observe(containerRef.current, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }

    // Also listen for window resize
    window.addEventListener('resize', sendHeightToParent);

    // Cleanup
    return () => {
      clearTimeout(timer);
      resizeObserver.disconnect();
      mutationObserver.disconnect();
      window.removeEventListener('resize', sendHeightToParent);
    };
  }, []);

  return (
    <Box 
      ref={containerRef}
      sx={{ 
        p: 0, 
        m: 0,
        minHeight: '100vh',
        bgcolor: '#ffffff',
        overflow: 'hidden'
      }}
    >
      <Box 
        component="main" 
        sx={{ 
            flexGrow: 1,
            display: 'flex', 
            flexDirection: 'column',
            //justifyContent: 'space-between',
            pl: { xs: 3, sm: 4, md: 6 }, 
            pr: { xs: 3, sm: 4, md: 6 },
            height: '100vh',
            overflowY: 'auto',
            overflowX: 'hidden'
        }}
      >
        <Outlet />
      </Box>
      <ContentPlayerModalContainer />
    </Box>
  );
};

export default EmbeddedLayout;